import {
  register,
  validateDataCard,
  validateEmail,
  validatePhone,
  validateDataBackground,
  validateDataSignature,
  validateDataContact,
} from "./validation";

import {
  createDetail,
  numberWithCommas,
  canvasPreview,
  formatTime,
  diffTimeMinutes,
  diffTimeSeconds,
  checkSizeData,
  transformSizeData,
  handleOnClickLogout,
  base64ToBytes,
  replaceUrl,
  numberWithAbbr,
  changeDateFormat,
  changeDateFilterFormat,
  getLinkedInUsernameRegex,
  getYouTubeUsernameFromUrl,
  getXUsernameFromUrl,
  setDateForFilter,
  generateCardSocial,
  checkIsMobile,
} from "./utils";

import {
  getAllCards,
  createCard,
  getAllLookUp,
  uploadImage,
  updateCard,
  getCardBySlug,
  deleteCard,
  getAllPackages,
  postPayment,
  getAllPayment,
  getActivePayment,
  getSpecificPayment,
  getUserPackage,
  getUserTransactions,
  getAnalytic,
  createBackground,
  getAllBackgrounds,
  getVCLookUp,
  deleteBackground,
  getBackground,
  updateBackground,
  getESLookUp,
  createSignature,
  getAllSignatures,
  deleteSignature,
  getSignature,
  updateSignature,
  postGift,
  getProfile,
  updateProfile,
  sentEmailResetPassword,
  getTicketInformations,
  postTicket,
  getContacts,
  createContact,
  deleteContact,
  getContact,
  updateContact,
  uploadFileContacts,
  downloadContacts,
  invokeOCR,
  uploadLinkContacts,
} from "./api";

import {
  cards,
  email,
  virtual_backgrounds,
  analytics,
  contacts,
} from "../assets";

import { contact, setting } from "../assets/helps";

import { urlHome, urlApi, urlSocket } from "./urls";

const dataLookUpConst = {
  Information: {
    Social: [
      {
        lookup_id: "LKPac0ab786b38b4ecabdee5ed5b6c8441e",
        category: "card_social",
        label: "fb",
        display_label: "Facebook",
        base_url: "https://facebook.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG57245b10c5c64aa4a646748b7c444b59.svg",
        created_at: "2025-07-18T19:28:35.478825",
        updated_at: "2025-07-18T19:28:35.478825",
      },
      {
        lookup_id: "LKP52e4c7bc87fe4d119bb1d1ddd540f54c",
        category: "card_social",
        label: "x",
        display_label: "X",
        base_url: "https://x.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGffb4164610954166a873d4e9130e7059.svg",
        created_at: "2025-07-18T19:37:23.919029",
        updated_at: "2025-07-18T19:37:23.919029",
      },
      {
        lookup_id: "LKPd35430f1de15438685504c87d07a8716",
        category: "card_social",
        label: "ig",
        display_label: "Instagram",
        base_url: "https://instagram.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGb92cb5f78e2d40d9b5266663cc3db62c.svg",
        created_at: "2025-07-18T19:37:25.080458",
        updated_at: "2025-07-18T19:37:25.080458",
      },
      {
        lookup_id: "LKP5a1d1313d4fe4625a0ca41bc7a0f4a9d",
        category: "card_social",
        label: "tiktok",
        display_label: "TikTok",
        base_url: "https://tiktok.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGacd6863673f449b19b094e6d8bddc948.svg",
        created_at: "2025-07-18T19:37:26.251444",
        updated_at: "2025-07-18T19:37:26.251444",
      },
      {
        lookup_id: "LKP2f5a4afa91e7431482e9fde30122868c",
        category: "card_social",
        label: "youtube",
        display_label: "Youtube",
        base_url: "https://youtube.com/@username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG07d9fb389d804524958ed651aa3b46e5.svg",
        created_at: "2025-07-18T19:37:27.501639",
        updated_at: "2025-07-18T19:37:27.501639",
      },
      {
        lookup_id: "LKPc6aa04a4b1f5475ca5a752c692f30717",
        category: "card_social",
        label: "linkedin",
        display_label: "LinkedIn",
        base_url: "https://www.linkedin.com/in/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG6da04208845c4965b4b343eed604ebd4.svg",
        created_at: "2025-07-18T19:37:28.820704",
        updated_at: "2025-07-18T19:37:28.820704",
      },
    ],
    Messaging: [
      {
        lookup_id: "LKP3cb4c0867b0f4a479b35b5bea1328fc3",
        category: "card_social",
        label: "phone",
        display_label: "Phone",
        base_url: null,
        placeholder: "628123456789",
        type: null,
        values: "personal,work",
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG2c37525234d0494ca0c167dbd72df75e.svg",
        created_at: "2025-07-18T19:37:30.149754",
        updated_at: "2025-07-18T19:37:30.149754",
      },
      {
        lookup_id: "LKP7867fa015b0240f3a7f06ad0d76a5021",
        category: "card_social",
        label: "wa",
        display_label: "Whatsapp",
        base_url: "https://wa.me/phone",
        placeholder: "628123456789",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG7191ceeb202c40d6b3f8705a827582ec.svg",
        created_at: "2025-07-18T19:37:31.335666",
        updated_at: "2025-07-18T19:37:31.335666",
      },
      {
        lookup_id: "LKPe1dbac505b3e46c2974eac91dd772c52",
        category: "card_social",
        label: "telegram",
        display_label: "Telegram",
        base_url: "https://t.me/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGaed4c9da598741a582d374cd8a51fe2b.svg",
        created_at: "2025-07-18T19:37:32.567224",
        updated_at: "2025-07-18T19:37:32.567224",
      },
      {
        lookup_id: "LKP8d00ffb749ce4cb4a26236888b7614e2",
        category: "card_social",
        label: "email",
        display_label: "E-mail",
        base_url: null,
        placeholder: null,
        type: null,
        values: "personal,work",
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG3fc615fefaf54b07b630877d32847e07.svg",
        created_at: "2025-07-18T19:37:33.669626",
        updated_at: "2025-07-18T19:37:33.669626",
      },
    ],
    Business: [
      {
        lookup_id: "LKP5bd1c2480cee429fb01572b7e2dbfd6f",
        category: "card_social",
        label: "github",
        display_label: "Github",
        base_url: "https://github.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG64ef1941d6d94c1c9439cb0862772d9e.svg",
        created_at: "2025-07-18T19:40:31.784289",
        updated_at: "2025-07-18T19:40:31.784289",
      },
      {
        lookup_id: "LKP0872d4a0c3de491abc94ca23100fb282",
        category: "card_social",
        label: "tokped",
        display_label: "Tokopedia",
        base_url: "https://www.tokopedia.com/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG6a2466bce5e54a49a96c759d27de9436.svg",
        created_at: "2025-07-18T19:40:33.131667",
        updated_at: "2025-07-18T19:40:33.131667",
      },
      {
        lookup_id: "LKP8faa4c8de5c84c43b4cfd489de44247c",
        category: "card_social",
        label: "shopee",
        display_label: "Shopee",
        base_url: "https://shopee.co.id/username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG58f8df0b6c004bd3a2edcda7c34cb80b.svg",
        created_at: "2025-07-18T19:40:34.426244",
        updated_at: "2025-07-18T19:40:34.426244",
      },
      {
        lookup_id: "LKPe336e440a0aa4ed89344fb38d8aea41e",
        category: "card_social",
        label: "medium",
        display_label: "Medium",
        base_url: "https://medium.com/@username",
        placeholder: "username",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGa62e05da4d884a619979eeec32964052.svg",
        created_at: "2025-07-18T19:40:35.707533",
        updated_at: "2025-07-18T19:40:35.707533",
      },
      {
        lookup_id: "LKP3a5e97b555694ad39ce25dcc83c6056d",
        category: "card_social",
        label: "website",
        display_label: "Website",
        base_url: null,
        placeholder: "https://nitomeyocard.com",
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG3436413f256b4165aa26a8cd4d0d6790.svg",
        created_at: "2025-07-18T19:40:36.937536",
        updated_at: "2025-07-18T19:40:36.937536",
      },
    ],
  },
  Display: {
    "Card Template": [
      {
        lookup_id: "LKP39253bd9a92147aabe53f206cedeaa80",
        category: "card_template",
        label: "straight",
        display_label: "Straight",
        base_url: null,
        placeholder: null,
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG08725bb5be0049098db7ab529e6dd619.svg",
        created_at: "2025-07-18T19:41:25.760214",
        updated_at: "2025-07-18T19:41:25.760214",
      },
      {
        lookup_id: "LKPc7daadb89f6c4a82bf9b85209034e5c5",
        category: "card_template",
        label: "oval",
        display_label: "Oval",
        base_url: null,
        placeholder: null,
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMG53dcb1fef05f443fb9ef50c8c197654f.svg",
        created_at: "2025-07-18T19:41:27.317271",
        updated_at: "2025-07-18T19:41:27.317271",
      },
      {
        lookup_id: "LKP11c48b2f4a3945ceb9d6558981b4c807",
        category: "card_template",
        label: "blur",
        display_label: "Blur",
        base_url: null,
        placeholder: null,
        type: null,
        values: null,
        image_url:
          "https://cdn.nitomeyocard.com/asset/IMGe789b4eea47e44fca113ddc526f49c91.svg",
        created_at: "2025-07-18T19:41:29.500415",
        updated_at: "2025-07-18T19:41:29.500415",
      },
    ],
    "Color Theme": [
      {
        lookup_id: "LKP14efd5d4e9e3462d883899efeea1b6d7",
        category: "color_theme",
        label: "nitomeyo",
        display_label: "Nitomeyo",
        base_url: null,
        placeholder: null,
        type: null,
        values: "001944,FF6500",
        image_url: null,
        created_at: "2025-07-18T19:48:20.984666",
        updated_at: "2025-07-18T19:48:20.984666",
      },
      {
        lookup_id: "LKP1511d6d78de9400eb9758bf1ee37deb9",
        category: "color_theme",
        label: "calm_profesional",
        display_label: "Calm and Profesional",
        base_url: null,
        placeholder: null,
        type: null,
        values: "7B9ACC,FCF6F5",
        image_url: null,
        created_at: "2025-07-18T19:48:21.197205",
        updated_at: "2025-07-18T19:48:21.197205",
      },
      {
        lookup_id: "LKPd7bca5b008ea4481bc20c57c5426cf47",
        category: "color_theme",
        label: "sophisticated_striking",
        display_label: "Shopisticated and Striking",
        base_url: null,
        placeholder: null,
        type: null,
        values: "A4193D,FFDFB9",
        image_url: null,
        created_at: "2025-07-18T19:48:21.369172",
        updated_at: "2025-07-18T19:48:21.369172",
      },
      {
        lookup_id: "LKP2767737eeaf14fbb88f9d3e9161c3ced",
        category: "color_theme",
        label: "bold_innovative",
        display_label: "Bold and Innovative",
        base_url: null,
        placeholder: null,
        type: null,
        values: "101820,F2AA4C",
        image_url: null,
        created_at: "2025-07-18T19:48:21.560328",
        updated_at: "2025-07-18T19:48:21.560328",
      },
      {
        lookup_id: "LKPb08c8005978a4db6bcfe9796d976498e",
        category: "color_theme",
        label: "energetic_grounded",
        display_label: "Energetic and Grounded",
        base_url: null,
        placeholder: null,
        type: null,
        values: "1E4174,DDA94B",
        image_url: null,
        created_at: "2025-07-18T19:48:21.775673",
        updated_at: "2025-07-18T19:48:21.775673",
      },
    ],
  },
};

const mainFeatures = [
  {
    id: "Cards",
    path: "/",
    icon: cards,
  },
  {
    id: "Email Signatures",
    path: "/signatures",
    icon: email,
  },
  {
    id: "Virtual Backgrounds",
    path: "/backgrounds",
    icon: virtual_backgrounds,
  },
  {
    id: "Analytics",
    path: "/analytics",
    icon: analytics,
  },
  {
    id: "Contacts",
    path: "/contacts",
    icon: contacts,
  },
];

const helpSettings = [
  {
    id: "Account Settings",
    path: "/setting",
    icon: setting,
  },
  {
    id: "Help & Support",
    path: "/support",
    icon: contact,
  },
];

const socialMedias = ["LinkedIn", "Facebook", "Instagram", "Twitter"];

export {
  register,
  urlHome,
  mainFeatures,
  getBackground,
  helpSettings,
  urlApi,
  createDetail,
  numberWithCommas,
  socialMedias,
  canvasPreview,
  formatTime,
  diffTimeMinutes,
  diffTimeSeconds,
  urlSocket,
  checkSizeData,
  transformSizeData,
  handleOnClickLogout,
  getAllCards,
  createCard,
  getAllLookUp,
  uploadImage,
  base64ToBytes,
  updateCard,
  getCardBySlug,
  replaceUrl,
  deleteCard,
  dataLookUpConst,
  validateDataCard,
  validateEmail,
  validatePhone,
  getAllPackages,
  numberWithAbbr,
  postPayment,
  getAllPayment,
  getActivePayment,
  getSpecificPayment,
  getUserPackage,
  changeDateFormat,
  changeDateFilterFormat,
  getLinkedInUsernameRegex,
  getYouTubeUsernameFromUrl,
  getXUsernameFromUrl,
  getUserTransactions,
  getAnalytic,
  setDateForFilter,
  validateDataBackground,
  createBackground,
  getVCLookUp,
  getAllBackgrounds,
  deleteBackground,
  updateBackground,
  getESLookUp,
  validateDataSignature,
  createSignature,
  getAllSignatures,
  deleteSignature,
  getSignature,
  updateSignature,
  postGift,
  getProfile,
  updateProfile,
  sentEmailResetPassword,
  getTicketInformations,
  postTicket,
  getContacts,
  createContact,
  generateCardSocial,
  validateDataContact,
  deleteContact,
  getContact,
  updateContact,
  uploadFileContacts,
  checkIsMobile,
  downloadContacts,
  invokeOCR,
  uploadLinkContacts,
};
